import { cx } from '@/lib/cx';

const SIZES = {
  sm: 'h-6 w-6 text-2xs',
  md: 'h-8 w-8 text-xs',
} as const;

function initials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  const first = parts[0]?.[0] ?? '';
  const last = parts.length > 1 ? (parts[parts.length - 1]?.[0] ?? '') : '';
  return (first + last).toUpperCase();
}

/** Initials avatar. Decorative by default — the name is expected alongside it. */
export function Avatar({
  name,
  size = 'md',
  className,
}: {
  name: string;
  size?: keyof typeof SIZES;
  className?: string;
}) {
  return (
    <span
      aria-hidden="true"
      className={cx(
        'grid shrink-0 place-items-center rounded-full bg-surface-sunken font-semibold text-fg-secondary select-none',
        SIZES[size],
        className,
      )}
    >
      {initials(name)}
    </span>
  );
}
